import { render, staticRenderFns } from "./SpecificExtraWorkArchive.vue?vue&type=template&id=ba3b2f92&scoped=true&"
import script from "./SpecificExtraWorkArchive.vue?vue&type=script&lang=js&"
export * from "./SpecificExtraWorkArchive.vue?vue&type=script&lang=js&"
import style0 from "./SpecificExtraWorkArchive.vue?vue&type=style&index=0&id=ba3b2f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3b2f92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VPagination,VRow,VSelect,VSpacer})
